export const PARTNER_APP_INTEGRATION_STATUSES = Object.freeze({
  ACTIVE: 'A',
  SUSPENDED: 'S',
  PAID: 'P',
  BLOCKED: 'B',
  DISABLED: 'D',
})

export const COMPANIES_WITH_DISABLED_BUTTON: readonly string[] = [
  'Booksy Med',
]

export const BM_BILLING_HUB_TAB_QUERY = 'billing_tab'
export const BM_BILLING_HUB_TAB_PAYMENTS = 'payments'
export const BM_PARTNER_APP_SUBSCRIPTION_TAB = 'subscription'
